import { Module } from '@nestjs/common';
import { ThemesController, StorefrontThemeController } from './themes.controller';
import { ThemesService } from './themes.service';
import { TenancyModule } from '../tenancy/tenancy.module';
import { AuthModule } from '../auth/auth.module';

@Module({
  imports: [TenancyModule, AuthModule],
  controllers: [ThemesController, StorefrontThemeController],
  providers: [ThemesService],
  exports: [ThemesService],
})
export class ThemesModule {}
